export const tr = {
    'add-minus-phrases': 'Negatif anahtar sözcük gruplarını ekle',
    'add-phrases': 'Sözcük grupları ekle',
    'add-phrases-to-group': 'Reklam grubuna ekle',
    'add-to-start': 'Başlangıç bölümüne ekle',
    'chosen-phrases': 'Seçilen sözcük grupları',
    'chosen-phrases-empty-header': 'Seçilenleri gruba ekleyin',
    'chosen-phrases-empty-text':
        'Reklam grubuna ekleyebileceğiniz anahtar sözcük gruplarının listesi burada gösterilir',
    'minus-phrases': 'Negatif anahtar sözcük grupları',
    'minus-phrases-empty-header': 'Seçilenleri gruba ekleyin',
    'minus-phrases-empty-text':
        'Reklam grubuna ekleyebileceğiniz negatif anahtar sözcük gruplarının listesi burada gösterilir',
    'minus-words': 'Negatif anahtar sözcükler',
    'phrase-selection': 'Sözcük grubu seçimi',
    phrases: 'Sözcük grupları',
    'phrases-input-placeholder': 'Sorguları virgülle ayırarak veya ( | ) operatörüyle girin',
    'search-also-phrases-empty-header': 'Başlangıç sorguları belirtilmedi',
    'search-also-phrases-empty-text': 'Sol sütunda seçilen başlangıç sorguları için benzer sorgular burada gösterilir',
    'search-also-phrases-not-exist-header': 'Benzer sorgu yok',
    'search-also-phrases-not-exist-text': 'Sol sütunda başlangıç sorgusunu değiştirin',
    'searched-also': 'Benzer',
    'searched-also-phrases': 'Benzer sorgular',
    'searched-with': 'Ekli',
    'shows-per-month': 'Aylık gösterim sayısı',
    'similar-phrases-empty-header': 'Başlangıç sorguları belirtilmedi',
    'similar-phrases-empty-text': 'Sol sütunda seçilen başlangıç sorguları için ekli sorgular burada gösterilir',
    'similar-phrases-not-exist-header': 'Ekli sorgu yok',
    'similar-phrases-not-exist-text': 'Sol sütunda başlangıç sorgusunu değiştirin',
    'start-phrases': 'Başlangıç sorguları',
    'start-phrases-empty-header': 'Sorgu belirtilmedi',
    'start-phrases-empty-text': 'Sorguları virgülle ayırarak girin'
};
